export const LANGUAGES = [
    { label: "English", code: "en" },
    { label: "Deutsch", code: "de" },
    { label: "Русский", code: "ru" },
    { label: "All", code: "all" },
];

export const AUDIO_FILES = [
    {
        id: 0,
        name: "New Bosanova",
        file: "/audio/new_bosanova_loop_drums.wav",
        bpm: 60,
    },
    {
        id: 1,
        name: "Indi Rock Tape Up",
        file: "/audio/Indie_Rock_Drums_V1_Intro02_TapeUp_80bpm.wav",
        bpm: 80,
    },
    {
        id: 2,
        name: "Zeppelin Inspired",
        file: "/audio/Bonhamology_Zeppelin-Inspired-Drums_v1_VrsABFill1_DropKich72bpm.mp3",
        bpm: 72
    },
    {
        id: 3,
        name: "Indi Rock Lower East Side",
        file: "/audio/Bonhamology_Zeppelin-Inspired-Drums_v1_VrsABFill1_DropKich72bpm.mp3",
        bpm: 140
    },
    {
        id: 4,
        name: "Indi Rock Lower East Side",
        file: "/audio/Indie_Rock_Drums_V1_TomGrv04_LowerEastSide_140bpm.mp3",
        bpm: 140
    },
    {
        id: 5,
        name: "Funky - Curt Bisquera_RBX Stick",
        file: "/audio/Curt_Bisquera_V2_A3_R_B_X_Stick_92bpm.mp3",
        bpm: 92
    },
    {
        id: 6,
        name: "Swunky Bonhamology",
        file: "/audio/Bonhamology_Swunky_87bmp.mp3",
        bpm: 87
    },
    {
        id: 7,
        name: "Bossa Sis V Teste",
        file: "/audio/bossa_sis_v_teste_bpm128.mp3",
        bpm: 128
    },
    {
        id: 8,
        name: "Funky - Clyd Stubblefield You Said Funky",
        file: "/audio/Clyd_Stubblefield_You_Said_Funky_100.mp3",
        bpm: 100
    },
    {
        id: 9,
        name: "Hat Groof Curt Bisquera",
        file: "/audio/Hat_Gruf_Curt_Bisquera_bmp90.mp3",
        bpm: 90
    },
    {
        id: 10,
        name: "ShuffScaf Brian Frasier",
        file: "/audio/ShufScaf_Brian_Frasier_106bmp.mp3",
        bpm: 90
    },

    /*
    "https://static.roomab.art/mp3/ne-moozhhet-biiit-ne-smeeshshsite-mmemenniiiiaaff8559b0668329cfe29804d0e9ea0c0e.mp3",
    "https://static.roomab.art/mp3/hhhvvkskakkatititti_nnaaaddoooeeelo_vvbnndvkaitiinyt_nnaaddoiieelo.mp3",
    "https://static.roomab.art/mp3/huuuuzzghhe_kooggllddsgg_cchhhehesshshuuttiuussia.mp3",


    "https://static.roomab.art/mp3/films_plus_cuts/zdravstvuyte_ya_vasha_tetya/vhhohoororossshsho_bby_vypiiitt.mp3",
    "https://static.roomab.art/mp3/kvn/KVN.2011.(1.1_8).mgimo.hren_s_nimi.mp3"*/
]
